var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconGoDeep({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.625,
    height: 16.625,
    viewBox: "0 0 16.625 16.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.946,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#137ac9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#039fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2200",
    "data-name": "Group 2200",
    transform: "translate(-23.375 -158)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-paginate-filter-video_24x24",
    "data-name": "streamline-icon-paginate-filter-video@24x24",
    transform: "translate(23.25 157.292)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1346",
    "data-name": "Rectangle 1346",
    width: 13.83,
    height: 13.759,
    rx: 1.5,
    transform: "translate(2.92 0.708)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M14.58,17.5H1.814A1.061,1.061,0,0,1,.75,16.446V3.746",
    transform: "translate(0 -0.797)",
    fill: "none",
    stroke: "#137ac9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M9.75,6.474V11.22a.474.474,0,0,0,.719.407l3.8-2.373a.475.475,0,0,0,0-.814l-3.8-2.373a.475.475,0,0,0-.719.406Z",
    transform: "translate(-2.123 -1.546)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconGoDeep);
export default __webpack_public_path__ + "static/media/streamline-icon-go-deep.b7913d73.svg";
export { ForwardRef as ReactComponent };